import type { TextColorPluginOptions } from '@atlaskit/editor-plugin-text-color/text-color-plugin-type';

interface Props {
	isPluginEnabled?: boolean;
	options: never;
}

export function textColorPluginOptions({ isPluginEnabled = true }: Props): TextColorPluginOptions {
	return {
		toolbarConfig: {
			enabled: isPluginEnabled,
		},
	};
}
